import angular from 'angular';
import gatherBoxComponent from './gather-box.component';
import localStorageModule from 'angular-local-storage';
import 'angular-file-upload';
import mediaAccount from '../../../../../modules/media-account/media-account';
import gatherTip from './message.service';
let gatherBoxModule = angular.module('gatherBox', [localStorageModule,'angularFileUpload',mediaAccount])

    .component('gatherBox', gatherBoxComponent)
    .service({gatherTip})
    .name;

export default gatherBoxModule;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/gather-box/gather-box.js